
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LoginDashboard from "../pages/admin/dashboard/page";
import CreateShipment from "../pages/admin/create-shipment/page";
import BulkUpload from "../pages/admin/bulk-upload/page";
import ShipmentDetails from "../pages/admin/shipment-details/page";
import CustomerTracking from "../pages/customer/tracking/page";
import UserManagement from "../pages/admin/user-management/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/admin",
    element: <LoginDashboard />,
  },
  {
    path: "/admin/create-shipment",
    element: <CreateShipment />,
  },
  {
    path: "/admin/bulk-upload",
    element: <BulkUpload />,
  },
  {
    path: "/admin/user-management",
    element: <UserManagement />,
  },
  {
    path: "/admin/shipment/:trackingId",
    element: <ShipmentDetails />,
  },
  {
    path: "/track",
    element: <CustomerTracking />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
